/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:36:08
 */
export default {
  lang: "英语",
  landing: {
    name1: "Open Carlcare",
    name2: "Reservation now",
    name3: "With Carlcare, you can check your order at any time.",
    name4: "Verification code",
    name5: "Slide to the right",
    name6: "Verification complete",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "Enjoy Carlcare Battery Replacement Service !", // 标题
    name10: "Enjoy an original battery replacement service for designated Infinix/Tecno/itel models, now available at Up to 50% off!",
    name11: "- Battery prices vary by model. Please check the updated price list below for more details.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Battery Replacement ?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name18: "3-Month Warranty",
    name19: "Get a 3-month official warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Get a great discount on battery prices.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name28: "4. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare Hotline at: 07080632363.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at 02-8705-4200.",
    name31: "Carlcare Service Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "यन्त्रको मोडल रोज्नुहोस्",
    name2: "खराबीको विवरण:",
    name3: "सेवा दिने पसल चयन गर्न ट्याप गर्नुहोस्",
    name4: "सेवा दिने पसल:",
    name5: "आरक्षण समय:",
    name6: "कृपया तपाईंको यन्त्रको समस्या विस्तारमा वर्णन गर्नुहोस्!",
    name7: "आगमन समय छान्न ट्याप गर्नुहोस्",
    name8: "हामीले तपाईंलाई सम्पर्क गर्न सकौँ भन्नका लागि कृपया आफ्नो सही सम्पर्क विवरण प्रविष्ट गर्नुहोस्",
    name9: "रिजर्भेसनका लागि उपलब्ध समय निम्नानुसार छ",
    name10: "कृपया आफ्नो फोन नम्बर प्रविष्ट गर्नुहोस्",
    name11: "मूल्य",
    name12: "व्यक्तिगत जानकारी:",
    name13: "कृपया आफ्नो नाम प्रविष्ट गर्नुहोस्",
    name14: "पेस गर्नुहोस्",
    name15: "रद्द गर्नुहोस्",
    name16: "ठिक छ",
  },
  shops: {
    name1: "तपाईंले रोजेको ब्रान्डका आधारमा, निम्न पसलहरूमा तपाईंले सेवा पाउन सक्नुहुन्छ!",
    name2: "थप खुद्रा पसलहरूमा चाँडै आउँदैछ! हामीसँग सम्पर्कमा रहनुहोस्!",
  },
  price: {
    name1: "ब्रान्ड",
    name2: "मोडेल",
    name3: "वस्तु",
    name4: "मूल्य",
    name5: "मैत्रीपूर्ण रिमाइन्डर:",
    name6: "यी मूल्यहरू सन्दर्भका लागि मात्र हुन् र वास्तविक मूल्य तपाईंको यन्त्रको अवस्थामा भर पर्छ।",
    name7: "कुनै विशेष चिन्ह छैन भने मूल्यको एकाइ स्थानीय मुद्राको एकाइ हुन्छ।",
    name8: "माफ गर्नुहोस्! हालको क्षेत्रमा मूल्यसम्बन्धी कुनै पनि जानकारी छैन।",
    name11:"श्रम लागत",
    name12:"जम्मा मूल्य",
    name13: "5. श्रम लागत \"/\" छ भने, श्रम लागतका बारेमा स्टोरसँग परामर्श गर्न आवश्यक हुन्छ।",
    item_main_board: "मेनबोर्ड",
    item_screen_frame: "स्क्रिन (फ्रेम)",
    item_screen_screen_frame: "माध्यमिक स्क्रिन (फ्रेम)",
    item_touch_screen: "टच स्क्रिन",
    item_camera: "क्यामेरा",
    item_fixed_focus_camera: "स्थिर फोकस क्यामेरा",
    item_auto_focus_camera: "स्वतः फोकस क्यामेरा",
    item_screen: "स्क्रिन",
    item_secondary_screen: "माध्यमिक स्क्रिन",
    item_fingerprint_module: "फिङ्गरप्रिन्ट मोड्युल",
    item_speaker: "स्पिकर",
    item_receiver: "प्राप्तकर्ता",
    item_small_board: "सानो बोर्ड",
    item_battery_cover: "ब्याट्री कभर",
    item_battery: "ब्याट्रि",
    item_charger: "चार्जर",
    item_usb_cable: "USB केबल",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "डाटा छैन",
    name2: "सेवा प्रदायक:",
    name3: "सेवाको ब्राण्ड:",
    name4: "टेलिफोन:",
    name5: "अर्डरको मात्रा:",
    name6: "सेवाको मूल्याङ्कन",
    name7: "सेवा वातावरण:",
    name8: "सेवा भाव:",
    name9: "सेवा दक्षता:",
    name10: "सेवाको गुणस्तर:",
    name11: "ग्राहक मूल्याङ्कन",
    name12:"मा",
    name13:"बन्द गरियो",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare खोल्नुहोस्",
    name1: "कृपया रिजर्भेसनसम्बन्धी जानकारीको स्क्रिनसट लिनुहोस् र प्राथमिकतामा राखिएको सेवा प्रयोग गर्न यसलाई एउटा रिसिप्टका रूपमा सुरक्षित गर्नुहोस्।",
    name2: "सफलता पूर्वक पेस गरियो",
    name3: "1. डेटा हटाउनुहोस्",
    name4: "कृपया महत्त्वपूर्ण व्यक्तिगत डेटा अग्रिम रूपमा आफ्नो फोनमा ब्याक अप गर्नुहोस्",
    name5: "2. पावर अन गर्दा पासवर्ड प्रविष्ट गर्नुपर्ने सेटिङ असक्षम पार्नुहोस्",
    name6: "सेवा प्रदान गर्ने पसलमा जानुभन्दा पहिला, कृपया:",
    name7: "सेवा दिने पसल:",
    name8: "आरक्षण समय:",
    name9: "खराबीको विवरण:",
    name10: "यन्त्रको मोडेल:",
    name11: "अर्डर नम्बर:",
    name12: "क्रमसम्बन्धी जानकारी",
  },
  title: {
   
    name1: "यो सेवा निम्न देशहरूमा उपलब्ध छ:",
    name2: "मोडेल रोज्नुहोस्",
    name3: "आरक्षण",
    name4: "सेवा दिने पसलको विवरण",
    name5: "सेवा दिने पसल छान्नुहोस्",
  },
  error: {
    
    name1: "कुनै पनि डेटा छैन। कृपया आफ्नो मर्मतसम्बन्धी जानकारी जाँच्नुहोस्",
    name2: "थप सहायता चाहियो? कृपया हामीलाई सम्पर्क गर्नुहोस्।",
    name3: "माफ गर्नुहोस्, हालको क्षेत्रमा Carlcare को कुनै पनि केन्द्र छैन।",
    name4: "कृपया सर्वप्रथम एउटा सेवा केन्द्र छान्नुहोस्",
    name5: "विफल भयो",
    name6: "कृपया सर्वप्रथम यन्त्रको मोडेल छान्नुहोस्",
    name7: "विवरणहरू",
    name8: "कृपया आफ्ना आवश्यकताहरू विस्तारमा वर्णन गर्नुहोस्",
    name9: "",
  },
  add1:{
    "name0": "ne-rNP",
    "name1": "तपाईंको अर्डर पुष्टि गरिएको छ। हामी तपाईंको आगमनका लागि प्रतीक्षारत रहने छौँ।",
    "name2": "शहर चयन गर्नुहोस्",
    "name3": "कृपया %1$s अङ्कको फोन नम्बर हाल्नुहोस्।",
    "name4": "बिदा बाहेकका दिनमा खुल्ने समय",
    "name5": "सोमबार",
    "name6": "मंगलवार",
    "name7": "बुधबार",
    "name8": "बिहिवार",
    "name9": "शुक्रबार",
    "name10": "शनिबार",
    "name11": "आइतबार",
    "name12": "देश प्रविष्ट गर्नुहोस् र खोज्नुहोस्"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "अन्य",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"पुनः निर्दिष्ट गर्न ट्याप गर्नुहोस्",
    name3:"अर्डर मूल्याङ्कन गर्न Carlcare अनुप्रयोग खोल्नुहोस्",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"सेवा चयन गर्नुहोस्",
    name7:"फ्रि क्लिनिङ",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "जानकारी गलत छ",
    "cancelReason1": "समयमै पुग्न सक्दैन",
    "cancelReason2": "दोहरिएको अर्डर/मेरो अर्डर होइन",
    "cancelReason3": "फेरि असफल हुन सक्दैन",
    "cancelReason4": "परीक्षण/सोधपुछ/कार्यक्रम/ का लागि मात्र…",
    "cancelReason5": "उच्च मूल्य",
    "cancelReason6": "सामग्रीको अभाव भएकाले",
    "cancelReason7": "कुनै फरक सेवा छैन",
    "cancelReason8": "स्टोर धेरै टाढा भएकाले",
    "cancelReason9": "स्टोर बन्द भएकाले",
    "cancelReason10": "खराब सेवाको मनोवृत्ति",
    "cancelReason11": "अन्य ब्राण्डहरूको प्रतिस्थापन/मर्मतसम्भार",
    "cancelReason12": "पसल फेला पार्न सकिएन",
    "cancelReason13": "अन्य",
    "cancelOrder": "अर्डर रद्द गर्नुहोस्",
    "reason_dialog_title": "कृपया हामीलाई रद्द गर्नुको कारण बताउनुहोस्",
    "Cancel": "रद्द गर्नुहोस्",
    "OK": "ठीक छ",
    "name1": "प्रमाणिकरण कोड प्रविष्ट गर्नुहोस्",
    "name2": "अमान्य प्रमाणीकरण कोड",
    "repair_reservation_detail_canceled": "यो अर्डर रद्द गरिएको छ!",
    "purchase_cancel_dialog_content": "तपाईं अर्डर रद्द गर्न पुष्टि गर्नुहुन्छ?",
    "yes": "हो",
    "no": "होइन"
}
};
